import { useContext } from 'react';
import { Check, Plus } from 'lucide-react';
import { useIntl } from 'react-intl';
import type { ComposerItemInput } from '../../stage/composer-draft.ts';
import { useComposerDraft } from '../../stage/ComposerDraftContext.tsx';
import { A2uiSurfaceContext } from '../surface-context.ts';
import { messages } from '../../localization/messages.ts';
import { Button } from '../../shadcdn/button.tsx';

/** Adds a removable subject or request to the normal composer. Never sends or commits. */
export function AddToMessage({
  item,
  label,
  disabled = false,
}: {
  item: ComposerItemInput;
  label?: string;
  disabled?: boolean;
}) {
  const api = useContext(A2uiSurfaceContext);
  const draft = useComposerDraft();
  const intl = useIntl();
  if (!api?.addToMessage) return null;
  const added = draft?.items.some(
    (candidate) => candidate.surfaceId === api.surfaceId && candidate.id === item.id,
  );
  const Icon = added ? Check : Plus;
  return (
    <Button
      type="button"
      variant="suggestion"
      size="surface"
      disabled={disabled}
      onClick={() => api.addToMessage?.(item)}
    >
      <Icon className="me-2 h-4 w-4" aria-hidden="true" />
      {added
        ? intl.formatMessage(messages.addedToMessage)
        : (label ?? intl.formatMessage(messages.addToMessage))}
    </Button>
  );
}
